import { print } from 'graphql'
import { Attribute, Cart } from 'shopify-types'

import { storefrontClient } from '..'
import {
  UpdateCartAttributesDocument,
  type UpdateCartAttributesMutation,
} from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

export const attributesUpdate =
  (options: GlobalRequestOptions) =>
  async (cartId: string, attributes: Attribute[]): Promise<Cart> => {
    const response = await storefrontClient.request<UpdateCartAttributesMutation>(
      print(UpdateCartAttributesDocument),
      {
        variables: {
          cartId,
          attributes,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartAttributesUpdate

    if (!payload?.cart) {
      throw new Error('Failed to update attributes')
    }

    return mapGQLCartToCart(payload.cart)
  }
